import React from 'react';

export default function Pagination({
  page = 1,
  totalPages = 1,
  total = 0,
  limit = 20,
  onPageChange,
  loading = false,
  actions = null,
}) {
  const start = total === 0 ? 0 : (page - 1) * limit + 1;
  const end = Math.min(page * limit, total);

  const pages = [];
  const maxButtons = 5;
  let startPage = Math.max(1, page - 2);
  let endPage = Math.min(totalPages, startPage + maxButtons - 1);
  startPage = Math.max(1, endPage - maxButtons + 1);
  for (let i = startPage; i <= endPage; i++) pages.push(i);

  return (
    <div className="admin-pagination">
      <span className="admin-pagination-info">
        Showing {start.toLocaleString()}–{end.toLocaleString()} of {total.toLocaleString()}
      </span>
      <div className="admin-pagination-right">
        <div className="admin-pagination-controls">
          <button
            type="button"
            className="cm-page-btn"
            disabled={loading || page <= 1}
            onClick={() => onPageChange(page - 1)}
            aria-label="Previous page"
          >
            <i className="fas fa-chevron-left" style={{ fontSize: 10 }} />
          </button>
          {pages.map((p) => (
            <button
              key={p}
              type="button"
              className={`cm-page-btn${p === page ? ' active' : ''}`}
              disabled={loading}
              onClick={() => onPageChange(p)}
            >
              {p}
            </button>
          ))}
          <button
            type="button"
            className="cm-page-btn"
            disabled={loading || page >= totalPages}
            onClick={() => onPageChange(page + 1)}
            aria-label="Next page"
          >
            <i className="fas fa-chevron-right" style={{ fontSize: 10 }} />
          </button>
        </div>
        {actions ? <div className="admin-pagination-actions">{actions}</div> : null}
      </div>
    </div>
  );
}
